import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import DatePickerMatch from "./DatePickerMatch";
import SoccerHeader from "./SoccerHeader";
import Loading from "../layout/Loading";
import Score from "../../assets/score.png";
import FootballPng from "../../assets/football.png";
import moment from "moment";
import RightLeague from "./RightLeague";

const AllMatchesNow = () => {
  const [allmatches, setAllmatches] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchdata = () => {
      fetch(
        `${process.env.REACT_APP_API_FOOTBALL}/fixtures/date/${moment(
          new Date()
        ).format("YYYY-MM-DD")}?api_token=${
          process.env.REACT_APP_API_TOKEN
        }&include=localTeam,visitorTeam`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }
      )
        .then((res) => {
          return res.json();
        })
        .catch((err) => {
          console.log(err);
        })
        .then((data) => {
          setLoading(false);
          setAllmatches(data.data);
        });
    };
    fetchdata();
  }, []);

  const showloading = () =>
    loading && (
      <div className="d-flex justify-content-center">
        <Loading />
      </div>
    );

  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-sm-9">
            <div className="container">
              <div className="card mt-2 card-curve">
                <div className="card-body p-0 soccer-bg">
                  <h2 className="text-center font-weight-bold text-muted mt-4">
                    <img src="https://img.icons8.com/emoji/50/000000/soccer-ball-emoji.png" />
                    Soccer
                  </h2>
                  <DatePickerMatch />
                </div>
              </div>
              {/* Live cricket score */}
              <div className="card mt-2 card-curve">
                <SoccerHeader />
                <h5 className="font-weight-bold m-4">
                  {" "}
                  <img src={FootballPng} width="40px" alt="" /> ALL MATCHES NOW
                </h5>
                {showloading()}
                {allmatches.map((livedata) => {
                  return (
                    <div key={livedata.id}>
                      {allmatches ? (
                        <Link
                          to={`/matchscore/${livedata.id}`}
                          className="link-item"
                        >
                          {" "}
                          <div className="card soccer-card mt-2 p-3 card-curve">
                            <div className="row mt-2">
                              <div className="col-sm-2">
                                {" "}
                                <p className="status text-center">
                                  {livedata.time.status}
                                </p>
                              </div>
                              <div className="col-sm-1"></div>
                              <div className="col-sm-3">
                                <p className="soccer-soccer-board">
                                  <img
                                    src={`${livedata.localTeam.data.logo_path}`}
                                    width="30px"
                                    alt="logo"
                                  />
                                  &nbsp;
                                  {livedata.localTeam.data.name} &nbsp;&nbsp;
                                </p>
                              </div>
                              <div className="col-sm-2">
                                <h4 className="soccer-score">
                                  {" "}
                                  {livedata.scores.localteam_score}&nbsp;&nbsp;
                                  {livedata.scores.visitorteam_score}
                                </h4>
                              </div>
                              <div className="col-sm-3">
                                <p className="soccer-soccer-board">
                                  {" "}
                                  <img
                                    src={`${livedata.visitorTeam.data.logo_path}`}
                                    width="30px"
                                    alt="logo"
                                  />
                                  &nbsp;
                                  {livedata.visitorTeam.data.name}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Link>
                      ) : (
                        <h2></h2>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="col-sm-3">
            {/* right leages  */}
            <RightLeague />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllMatchesNow;
